import React from 'react';
import {Box, Grid, Hidden} from "@material-ui/core";
import {bool, object, string} from "yup";

import {FormWrapper, SubmitBtnMerchant} from "../../../../../../../helpers/FormHandlers";
import {MerchantInput, MerchantSelect, MerchantSwitch} from "../../../../../../../helpers/InputsHelpers";

import {
  bankAccountId$,
} from '../state';
import {pushLocation} from "../../../../../../../../router";
import {LINK_MANAGEMENT} from "../../../../../../../../constants/links";
import {STABLECOINS} from "../../../../../../../../constants";
import {
  apiV2StableCoinAccountCreate, apiV2StableCoinAccountDetails, apiV2StableCoinAccountList,
  apiV2StableCoinAccountUpdate
} from "../../../../../../../../api/merchant/stablecoin";
import trim from "mn-utils/trim";
import upperFirst from "mn-utils/upperFirst";
import validateCoin from "../utils/valideteCoin";

export default () => {
  const [loading, setLoading] = React.useState(true);

  const [dataToEdit, setDataToEdit] = React.useState({});
  const [coins, setCoins] = React.useState(STABLECOINS);

  const id = bankAccountId$.getValue();
  const isEdit = id !== 'create';

  const handleBack = () => {
    pushLocation({
      path: LINK_MANAGEMENT + '?type=stablecoinAccounts',
    });
  };

  React.useEffect(async () => {
    if (!isEdit) {
      const availableBanks = await apiV2StableCoinAccountList({offset: 0, limit: 100})
        .then((res) => (res.list || []));

      const coins = STABLECOINS.reduce((acc, next) => {
        if (!next.active) return acc;

        const networks = next.networks.filter((network) => {
          return !availableBanks.find((el) => {
            return el.asset_code === next.id && el.asset_network === network;
          })
        });

        if (!networks.length) return acc;

        acc.push({
          id: next.id,
          name: next.name,
          networks
        });

        return acc;
      }, [])

      setCoins(coins);
      setLoading(false);
      return;
    }

    apiV2StableCoinAccountDetails({id})
      .then((res = {}) => {
        setDataToEdit({
          currency: res.asset_code,
          network: res.asset_network,
          address: res.address,
          tag: res.address_tag,
          primary: res.primary || false,
        });
        setLoading(false);
      })
  }, []);

  if (loading) return <span />;
  if (!isEdit && !coins.length) {
    return (
      <Box mt="3.5rem">
        All available stablecoin currency accounts have been created. Please modify or remove any existing accounts as needed.
      </Box>
    );
  }

  const currencies = coins.map((el) => ({id: el.id, name: el.name}));
  const networks = coins.reduce((acc, next) => {
    if (next.id && next.networks) {
      acc[next.id] = next.networks.map((id) => ({id, name: upperFirst(id)}));
    }
    return acc;
  }, {});

  const schema = object({
    currency: string().required(),
    network: string().required(),
    address: string()
      .test(
        'ccAddress',
        'Wrong address format',
        (val, ctx) => {
          const network = ctx.parent.network;
          return network ? validateCoin(val, network) : true;
        }
      )
      .required(),
    tag: string(),
    primary: bool()
  });

  const onSubmit = (data) => {
    const fn = isEdit
      ? apiV2StableCoinAccountUpdate
      : apiV2StableCoinAccountCreate;

    const params = {
      asset_code: data.currency,
      asset_network: data.network,
      address: data.address,
      address_tag: data.tag,
      primary: data.primary || false
    };

    if (isEdit) {
      params.id = id;
    }

    return fn(params)
  };

  return (
    <Box mt="2rem">
      <FormWrapper
        data={dataToEdit}
        schema={schema}
        onSubmit={onSubmit}
        onResult={handleBack}
        resultModalData={[isEdit ? 'Stablecoin account has been changed' : 'Stablecoin account has been created']}
      >{(formCtx) => {

        const primarySwitcher = (
          <MerchantSwitch
            text="Set as a primary"
            name="primary"
            formCtx={formCtx}
            disableLabel
          />
        );

        const currency = formCtx.state.data.currency;
        const networksList = !!currency ? networks[currency] : [];

        return (
          <>
            <Grid container spacing={4}>
              <Grid item sm={6} xs={12}>
                <MerchantSelect
                  propValue="id"
                  propName="name"
                  items={currencies}

                  label="Set Currency"
                  name="currency"
                  formCtx={formCtx}
                  disabled={isEdit}
                />
              </Grid>
              <Grid item sm={6} xs={12}>
                <MerchantSelect
                  propValue="id"
                  propName="name"
                  items={networksList}

                  label="Set Network"
                  name="network"
                  formCtx={formCtx}
                  disabled={isEdit || !networksList.length}
                />
              </Grid>
              <Grid item sm={6} xs={12}>
                <MerchantInput
                  name="address"
                  formCtx={formCtx}
                  onChangeHandlers={[trim]}
                />
              </Grid>
              <Grid item sm={6} xs={12}>
                <MerchantInput
                  label="Address tag"
                  name="tag"
                  formCtx={formCtx}
                />
              </Grid>
              <Hidden smUp>
                <Grid item sm={6} xs={12}>
                  {primarySwitcher}
                </Grid>
              </Hidden>
              <Grid item sm={6} xs={12}>
                <Box maxWidth="40rem">
                  <SubmitBtnMerchant formCtx={formCtx}>
                    {isEdit ? 'Update Account' : 'Add Account'}
                  </SubmitBtnMerchant>
                </Box>
              </Grid>
              <Hidden xsDown>
                <Grid item sm={6} xs={12}>
                  <Box mt=".65rem">
                    {primarySwitcher}
                  </Box>
                </Grid>
              </Hidden>
            </Grid>
          </>
        )
      }}</FormWrapper>
    </Box>
  )
}
